import { gql } from '@apollo/client';
const GET_ORDER_SUPPLIERS_PAGINATED = gql `
  query GetOrderSuppliersPaginated($id: ID!, $first: Int, $after: String, $supplierId: ID) {
    node(id: $id) {
      ... on OrderNode {
        id
        orderId
        suppliersCount(supplierId: $supplierId)
        componentVariantsBySuppliersConnection(
          first: $first
          after: $after
          supplierId: $supplierId
        ) {
          pageInfo {
            hasNextPage
            endCursor
            startCursor
          }
          edges {
            cursor
            node {
              id
              orderSupplier {
                id
                supplier {
                  id
                  code
                  shortName
                  fullName
                }
              }
              componentVariants {
                id
                name
                calculatedConsumption
                consumptionOverride
                consumptionEditAvailable
                componentAttributesPL
                variantAttributesPL
                componentAttributesEN
                variantAttributesEN
                ready
                productionStartDate
                productionEndDate
                deliveries {
                  id
                  deliveryType
                  quantityPlanned
                  quantityCollected
                  plannedDate
                  collectedDate
                  timelineStartDate
                  timelineEndDate
                  status
                  deliveryOrdinal
                }
                orderOperatorOfOrder {
                  id
                  orderOperator {
                    id
                    name
                  }
                }
                componentCategory {
                  id
                  type
                  typeLabelPL
                  typeLabelEN
                  precision
                  consumptionType {
                    id
                    name
                    labelPL
                    labelEN
                    integerValues
                  }
                }
              }
            }
          }
        }
      }
    }
  }
`;
export default GET_ORDER_SUPPLIERS_PAGINATED;
